import pagination from '@iso/lib/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('promotionDurationList');

const actions = {
    requestFetchPromotionDurationList: baseActions.request,
    fetchPromotionDurationListSucceeded: baseActions.succeeded,
    fetchPromotionDurationListFailed: baseActions.failed,
};

export { types, actions };

export default reducer;